import { useState, useCallback } from "react";

export const useAlertModal = () => {
    const [alertState, setAlertState] = useState({
        open: false,
        title: "",
        description: "",
        icon: null,
        iconColor: "text-amber-500",
        confirmText: "Confirm",
        cancelText: "Cancel",
        confirmButtonColor: "bg-red-500 hover:bg-red-600",
        onConfirm: null,
        onCancel: null,
    });

    const showAlert = useCallback((config) => {
        setAlertState((prev) => ({
            ...prev,
            open: true,
            ...config,
        }));
    }, []);

    const closeAlert = useCallback(() => {
        setAlertState((prev) => ({
            ...prev,
            open: false,
        }));
    }, []);

    const handleConfirm = useCallback(() => {
        if (alertState.onConfirm) {
            alertState.onConfirm();
        }
        closeAlert();
    }, [alertState, closeAlert]);

    const handleCancel = useCallback(() => {
        if (alertState.onCancel) {
            alertState.onCancel();
        }
        closeAlert();
    }, [alertState, closeAlert]);

    const handleOpenChange = useCallback(
        (open) => {
            if (!open) {
                closeAlert();
            }
        },
        [closeAlert]
    );

    return {
        ...alertState,
        showAlert,
        closeAlert,
        handleConfirm,
        handleCancel,
        handleOpenChange,
    };
};
